// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QO1mmYEub_FtX1IWo0wQ{display:flex;align-items:center}.C7Prhva5pj2wND186wyA{margin-left:12px;margin-right:4px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/compliance/pages/tollFree/pages/UseCaseDetails/ui/StatusLine/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,kBAAA,CAEF,sBACE,gBAAA,CACA,gBAAA","sourcesContent":[".statusLineWrapper {\n  display: flex;\n  align-items: center;\n}\n.estimateText {\n  margin-left: 12px;\n  margin-right: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statusLineWrapper": `QO1mmYEub_FtX1IWo0wQ`,
	"estimateText": `C7Prhva5pj2wND186wyA`
};
export default ___CSS_LOADER_EXPORT___;
